import { render, staticRenderFns } from "./InCellVisits.vue?vue&type=template&id=652c499c&"
import script from "./InCellVisits.vue?vue&type=script&lang=js&"
export * from "./InCellVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports